import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import logger from "../utils/LoggerFrontend";
import useTagManager from "./useTagManager";
import styled from "styled-components";

const TEMPLATES_DE = require("../../../locales/de.json");
const TEMPLATES_EN = require("../../../locales/en.json");

const locales = {
  "en-EN": TEMPLATES_EN,
  "en-US": TEMPLATES_EN,
  "en-GB": TEMPLATES_EN,
  en: TEMPLATES_EN,
  "de-DE": TEMPLATES_DE
};
const DEFAULT_LOCALE = TEMPLATES_DE;

const ApplyModal = styled.div`
  visibility: visible;
  pointer-events: auto;
  opacity: 1;
`;

const Wrapper = styled.div`
  width: 100%;
  max-width: 700px;
  position: relative;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 30px 30px rgba(50, 50, 70, 0.1);
  margin: 40px auto;
  z-index: 500;
  padding: 20px;

  h1 {
    line-height: 1.4em;
  }
`;

const Checkmark = styled.svg`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: block;
  stroke-width: 2;
  stroke: #fff;
  stroke-miterlimit: 10;
  margin: 10% auto;
  box-shadow: inset 0px 0px 0px #7ac142;
  animation: fill 0.4s ease-in-out 0.4s forwards, scale 0.3s ease-in-out 0.9s both;

  circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke: #7ac142;
    fill: none;
    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
  }

  path {
    transform-origin: 50% 50%;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
  }
`;

const AtsThankYou = ({ match, location }) => {
  useTagManager();
  const { email, phone, language } = location.state || {};
  const data = locales[language] || DEFAULT_LOCALE;
  const { orgaId, campaignId } = match.params;

  logger.log("AtsThankYouPage", "thank you page called:", {
    campaignId,
    orgaId,
    language,
    email,
    phone
  });

  useEffect(() => {
    if (window.analytics) {
      window.analytics.track("formSubmitted", {
        email,
        phone_number: phone
      });
    }

    if (window.dataLayer) {
      window.dataLayer.push({
        event: "formSubmitted",
        leadsUserData: {
          email,
          phone_number: phone
        }
      });
    }
  }, []);

  return (
    <ApplyModal>
      <Wrapper>
        <Checkmark xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
          <circle cx="26" cy="26" r="25" fill="none" />
          <path fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
        </Checkmark>

        <h1>
          {data.leadAds.thanks} <br />
          {data.leadAds.forYourApplication}!
        </h1>
        <p>{data.leadAds.thanksDisclaimer}.</p>
      </Wrapper>
    </ApplyModal>
  );
};

export default withRouter(AtsThankYou);
